import {
    Dispatch, SetStateAction,
} from 'react'
import {
    Toolbar,
} from '@mui/x-data-grid-pro'

import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'

import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import QuickFilterToolbarItem
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/QuickFilterToolbarItem'
import {
    TableFilterParams,
} from 'app/types/common.types'

import useStyles from './SkyNetDataGridToolbar.style'
import DefaultViewToolbarActions from './DefaultViewToolbarActions'
import ReducedViewToolbarActions from './ReducedViewToolbarActions'
import useTabsVisibility from './hooks/useTabsVisibility'

export type ToolbarSharedProps = {
    toolbarControls: JSX.Element[],
    showFilterButton: boolean
    toolbarActions: ActionComponentsKey[]
    toolbarActionsProps: {
        getFilterParams: () => TableFilterParams
    }
}

export type SetPanelTargetElFn = Dispatch<SetStateAction<HTMLButtonElement | null>>

type Props = ToolbarSharedProps & {
    tabsComponent: JSX.Element,
    isDetailsView: boolean
    setPanelTargetEl: SetPanelTargetElFn
}

export default function SkyNetDataGridToolbar({
    toolbarControls,
    tabsComponent,
    showFilterButton,
    isDetailsView,
    setPanelTargetEl,
    toolbarActions,
    toolbarActionsProps,
}: Readonly<Props>) {
    const {
        classes,
    } = useStyles()

    const {
        showTabs,
        handleInputExpand,
        handleResizeContainer,
    } = useTabsVisibility({
        isDetailsView,
    })

    return (
        <Toolbar
            data-testid="custom-toolbar"
            className={classes.toolbar}
        >
            {showTabs
                && (
                    <Box
                        sx={{
                            mr: 2,
                        }}
                    >
                        {tabsComponent}
                    </Box>
                )}
            <div
                className={classes.buttonsContainer}
                style={{
                    width: isDetailsView ? '100%' : undefined,
                }}
            >
                <QuickFilterToolbarItem
                    useDynamicWidth={isDetailsView}
                    onExpand={handleInputExpand}
                    onContainerResize={handleResizeContainer}
                />
                <Divider
                    orientation="vertical"
                    flexItem
                    variant="middle"
                    sx={{
                        ml: 1,
                        mr: 0.2,
                        height: '20px',
                    }}
                />
                {isDetailsView ? (
                    <ReducedViewToolbarActions
                        toolbarControls={toolbarControls}
                        toolbarActions={toolbarActions}
                        showFilterButton={showFilterButton}
                        setPanelTargetEl={setPanelTargetEl}
                        toolbarActionsProps={toolbarActionsProps}
                    />
                ) : (
                    <DefaultViewToolbarActions
                        toolbarControls={toolbarControls}
                        toolbarActions={toolbarActions}
                        showFilterButton={showFilterButton}
                        toolbarActionsProps={toolbarActionsProps}
                    />
                )}
            </div>
        </Toolbar>
    )
}
